import { IOfferSchema } from '../repositories/chats/entities/get_my_offers_for_selection/OfferSchema';
import { IPageSchema } from '../repositories/chats/entities/get_my_offers_for_selection/PageSchema';
import {
  fetchGetMyOffersForSelectionDesktop,
  IGetMyOffersForSelectionDesktopRequest,
  TGetMyOffersForSelectionDesktopResponse,
} from '../repositories/chats/v1/get-my-offers-for-selection-desktop';
import { TContext } from '../types/context';
import { EExceptionDomain } from '../types/exceptionDomains';
import { getGenericLikeError } from '../utils/logging/getGenericLikeError';
import { getResponseError } from '../utils/logging/getResponseError';

const DEFAULT_ERROR_MESSAGE = 'Ошибка при получении списка объявлений для селектора';

type TFetchSelectorOffersParams = {
  parameters: IGetMyOffersForSelectionDesktopRequest;
  cookies?: string;
};

interface IResponse {
  offers: IOfferSchema[];
  page?: IPageSchema;
  statusCode?: number;
}

export const fetchOffersForSelection = async (
  { logger, httpApi }: TContext,
  { cookies, parameters }: TFetchSelectorOffersParams,
): Promise<IResponse> => {
  try {
    const { response, statusCode }: TGetMyOffersForSelectionDesktopResponse = await fetchGetMyOffersForSelectionDesktop(
      {
        httpApi,
        parameters,
        config: {
          requestConfig: {
            headers: cookies ? [['Cookie', cookies]] : [],
            withCredentials: true,
          },
        },
      },
    );

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.OffersForSelection,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return {
      offers: response.offers,
      page: response.page,
      statusCode,
    };
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.OffersForSelection,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.warning(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/get-my-offers-for-selection-desktop/',
      parameters: JSON.stringify(parameters),
    });

    return { offers: [] };
  }
};
